import React, { memo } from 'react'
import {
  BWText,
  BWInput,
  positiveNumberRule,
  requiredRule,
  cssGap,
  SIZE_UNIT,
  CSS_FULL_WIDTH,
  CSS_WORD_BREAK_ALL,
  CSS_CENTERED_COLUMN_GRID,
  CSS_GRID,
  CSS_GRID_COLUMN,
  CSS_ITEMS_CENTER,
  CSS_POSITION_RELATIVE,
  formatCurrencyValue
} from 'src/libs/qb-brand-web-components'
import styled from '@emotion/styled'

import { EXCHANGE_PROVIDER_PROFILE_DISPATCH } from '../../store/reducers/exchange/exchangeProviders'
import Button from '../shared/button/Button'
import customConfig from 'customConfig'
import { ExchangeDivider, HorizontalLine } from '../shared/common'
import Panel from '../shared/panel/Panel'
import { LABEL_TEXT } from '../../constants/messages'
import { formatTicks } from '../../util/string.helpers'

const ExchangeCalculator = ({
  description,
  minPoints,
  maxPoints,
  symbol,
  exchangeRate,
  noExchangeRate,
  targetProviderSymbol,
  maxLength,
  submitLabel,
  onSubmit,
  dispatchAction,
  exchangeProviderProfile: { error, pointsAmount },
  t,
  disabled,
  exchangeValue,
  exchangeLabel,
  icon
}) => {
  return (
    <Panel padding={30} as='form' onFormSubmit={onSubmit}>
      <PointsFieldContainer>
        {description && (
          <BWText
            label={description}
            customCss={{ marginBottom: 15 }}
            alignCenter
          />
        )}
        <BWText
          label={`${LABEL_TEXT.MIN}. ${minPoints} ${symbol} - ${LABEL_TEXT.MAX}. ${maxPoints} ${symbol}`}
          alignCenter
          weight={700}
        />
        <BWInput
          label={t('exchange.points-amount')}
          value={pointsAmount}
          maxLength={maxLength}
          error={t(error[EXCHANGE_PROVIDER_PROFILE_DISPATCH.POINTS_AMOUNT])}
          validate={[requiredRule, positiveNumberRule]}
          positiveNumber
          onChange={(value) =>
            dispatchAction(
              EXCHANGE_PROVIDER_PROFILE_DISPATCH.POINTS_AMOUNT,
              value
            )
          }
          help={
            !noExchangeRate &&
            t('exchange.exchange-rate', {
              brandPoints: `1 ${symbol}`,
              targetBrandPoints: `${formatCurrencyValue(exchangeRate, 3)} ${targetProviderSymbol}`
            })
          }
        />
        <ExchangeDivider>
          <HorizontalLine />
          <HorizontalLine />
        </ExchangeDivider>
        <ExchangeCalculatorContainer>
          <ExchangeIconContainer>{icon}</ExchangeIconContainer>
          <ExchangeTextContainer>
            <BWText
              label={formatTicks(exchangeValue)}
              size={50}
              weight={800}
              alignCenter
              customCss={CSS_WORD_BREAK_ALL}
            />
            <BWText label={exchangeLabel} alignCenter />
          </ExchangeTextContainer>
        </ExchangeCalculatorContainer>
      </PointsFieldContainer>
      <Button
        label={t(submitLabel, {
          pointsLabel: t(customConfig.pointsLabel)
        })}
        type='submit'
        disabled={disabled}
      />
    </Panel>
  )
}

export default memo(ExchangeCalculator)

const PointsFieldContainer = styled.div`
  ${CSS_CENTERED_COLUMN_GRID};
  ${CSS_FULL_WIDTH};
  ${cssGap(SIZE_UNIT.SM)};
`

const ExchangeCalculatorContainer = styled.div`
  ${CSS_GRID};
  ${CSS_GRID_COLUMN};
  ${CSS_FULL_WIDTH};
  ${CSS_ITEMS_CENTER};
  grid-template-columns: auto 1fr;
  place-items: baseline;
`

export const ExchangeTextContainer = styled.div`
  ${CSS_GRID};
  ${CSS_FULL_WIDTH};
  grid-auto-flow: row;
  place-items: end;
`

const ExchangeIconContainer = styled.div`
  ${CSS_POSITION_RELATIVE};
  top: 15px;
`
